export default __webpack_public_path__ + "static/media/847.4f1173a6.png";